import { Component, Input, OnInit } from '@angular/core';
import { version } from "../../environments/version";

@Component({
  selector: 'app-version-number',
  templateUrl: './version-number.component.html',
  styleUrls: ['./version-number.component.css']
})
export class VersionNumberComponent implements OnInit {

  year: number;
  quarter: number;
  commit: string;

  @Input() absolutePlacement: boolean = false;

  constructor() { }

  ngOnInit() {
    this.year = version.year;
    this.quarter = version.quarter;
    this.commit = version.commit;
  }

}
